<div class="row form-group">
	<div class="col-12">
		<label>{{ "name" | langVal }}</label>
		<app-gen-input
			[actualObj]="meetingRequest"
			[errors]="errors"
			fieldName="name"
			autofocus
			tabindex="10001"
			(keyupEvent)="validateEntireForm()"
		>
		</app-gen-input>
	</div>
</div>
<div class="row form-group">
	<div class="col-12">
		<label>{{ "email" | langVal }}</label>
		<app-gen-input
			[actualObj]="meetingRequest"
			[errors]="errors"
			fieldName="email"
			autofocus
			tabindex="-1"
			(keyupEvent)="validateEntireForm()"
		>
		</app-gen-input>
	</div>
</div>
<div class="row form-group">
	<div class="col-12">
		<label>{{ "phone" | langVal }}</label>
		<app-gen-input
			[actualObj]="meetingRequest"
			[errors]="errors"
			fieldName="phone"
			autofocus
			tabindex="-1"
			(keyupEvent)="validateEntireForm()"
		>
		</app-gen-input>
	</div>
</div>
<div class="row form-group">
	<div class="col-12">
		<label>{{ "remarks" | langVal }}</label>
		<app-gen-input
			[actualObj]="meetingRequest"
			[errors]="errors"
			fieldName="remarks"
			autofocus
			tabindex="-1"
			(keyupEvent)="validateEntireForm()"
		>
		</app-gen-input>
	</div>
</div>

<div class="modal-btns">
	<app-cancel-btn (click)="onClose.emit()" />
	<app-btn-ext
		text="save"
		[disabled]="!isFormSubmittable"
		tabindex="10002"
		(clickEv)="submit()"
		[isSpin]="isSaving"
	/>
</div>
